import * as React from "react";
import { Grid, Button, Header } from "semantic-ui-react";

import { DayOfWeek, ArrayOfDays } from "../../interfaces";
import { getDayOfWeekState } from "../../utils";

import "./styles.scss";
import { DateTimePicker } from "../DateTimePicker";

interface Props {
  selectedDays: DayOfWeek[];
  selectedTime: Date | undefined;
  description?: string;
  editable?: boolean;
  onChangeDays: (value: DayOfWeek[]) => any;
  onChangeTime: (value: Date | undefined) => any;
}

export const MultipleDaySelectorComponent = ({
  selectedDays,
  selectedTime,
  editable = true,
  description = "Days we should send randomized prompts to your players",
  onChangeDays,
  onChangeTime,
}: Props) => {
  const daysMap = getDayOfWeekState(selectedDays);

  const toggleSelectedDay = (dayOfWeek: DayOfWeek) => {
    daysMap[dayOfWeek] = !daysMap[dayOfWeek];
    onChangeDays(ArrayOfDays.filter(day => daysMap[day]));
  };

  return (
    <div className={"dayOfWeekGridComponent"}>
      {description && (
        <Grid.Row>
          <Header as="span" className={"smallLeftPadding"} floated={"right"}>
            {description}
          </Header>
        </Grid.Row>
      )}
      <Grid.Row className={"noPadding daysRow"}>
        {ArrayOfDays.map(dayOfWeek => (
          <Grid.Column key={"multi_days_selector_" + dayOfWeek} width={2} textAlign={"center"} className={"noPadding"}>
            <Button
              className={editable ? "" : "disabled"}
              data-elm-id={`multidaysSelectorBtn`}
              type={"button"}
              toggle
              fluid
              name={dayOfWeek}
              active={daysMap[dayOfWeek]}
              onClick={(e: any) => {
                toggleSelectedDay(e.target.name as DayOfWeek);
              }}
            >
              {dayOfWeek.substring(0, 3)}
            </Button>
          </Grid.Column>
        ))}
      </Grid.Row>
      <Grid.Row className={"noPadding"}>
        <DateTimePicker selectedTime={selectedTime} onChangeTime={onChangeTime} editable={editable} timeOnly />
      </Grid.Row>
    </div>
  );
};
